/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

const LazyForgeUnitoAsanaDevIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-forge-unito-asana-dev" */ './utils').then(
			(m) => m.ForgeUnitoAsanaDevIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/forge-unito-asana-dev/icon' },
);

const LazyForgeUnitoAsanaDevSearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-forge-unito-asana-dev-search-result" */ './utils').then(
			(m) => m.ForgeUnitoAsanaDevSearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/forge-unito-asana-dev/search-result-icon' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const ForgeUnitoAsanaDevIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyForgeUnitoAsanaDevIconComponent />
	</Suspense>
);

export const ForgeUnitoAsanaDevSearchResultIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyForgeUnitoAsanaDevSearchResultIconComponent />
	</Suspense>
);
